import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { parse } from 'node-html-parser';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

export function useShortcode(rendered = '', { ...rest }) {
  const [hasError, setErrors] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px 200px 0px',
    threshold: 0,
  });

  const shortcode = parse(rendered).rawText.trim().replace('[', '').replace('/]', '');

  async function fetchData() {
    if (!inView) return;

    const location = window.location;
    const requestUrl = `${location.protocol}//${location.host}`;

    const request = `${requestUrl}/wp-json/bda-cli/v2/shortcodes/shortcode?raw=${shortcode}`;

    const res = await fetch(request);
    res
      .json()
      .then(res => {
        setData(res);
        setLoaded(true);
        return res;
      })
      .catch(err => setErrors(err));
  }

  useEffect(() => {
    fetchData();
  }, [inView]);

  return [ref, data, loaded, hasError];
}
